import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Card, CardContent, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TableRow, } from '@mui/material';
import { GeneralDownlinkPayloadAttributeRangeLimits, isNonNaNNumber } from '@iotv/iotv-v3-types';
import React, { useEffect } from 'react';
import { getObjectHash, objectsMatch } from '@iotv/datamodel-core';
import { SimpleNumberRowGeneric } from './SimpleNumberRowGeneric';
const debug = process.env.REACT_APP_DEBUG && false;
const verify = 0x5a;
export const GeneralConfigCard = ({ handleSendTransactionButtonClick, setReceivedDeviceControlTransactions, selectedDevices, deviceConfig, }) => {
    const [hasEdits, setHasEdits] = React.useState(false);
    // Here be gotchas, currently we only have provision for one initial value, and we would like to support multiple sends
    const firstDevice = selectedDevices[0];
    const initial = {
        // adr: 1,
        appCycleTime: 5,
        // dr: 2,
        sysCycleTime: 60,
    };
    const [desiredPayload, setDesiredPayload] = React.useState(undefined);
    const [reportedSettings, setReportedSettings] = React.useState(undefined);
    const deviceConfigHash = getObjectHash(deviceConfig);
    useEffect(() => {
        const reported = deviceConfig?.requested;
        debug && console.log('General Config card used effect on ', { deviceConfig, reported });
        const { appCycleTime, sysCycleTime } = reported ?? {};
        // AppCycle and SysCycle currently not in reported so using requested as proxy
        if (isNonNaNNumber(appCycleTime) && isNonNaNNumber(sysCycleTime))
            setReportedSettings({ appCycleTime, sysCycleTime });
    }, [deviceConfigHash]);
    if (desiredPayload === undefined) {
        setDesiredPayload(initial);
    }
    const handleDownlinkReqConfig = () => handleSendTransactionButtonClick({
        sendConfig: true,
    });
    const handleDownlinkClearErrors = () => handleSendTransactionButtonClick({
        clearErrorCodes: true,
    });
    const handleDownlinkReboot = () => handleSendTransactionButtonClick({
        reboot: true,
    });
    const handleDownlinkRestore = () => handleSendTransactionButtonClick({
        restoreDefaults: true,
    });
    // limits = Payload.DownlinkPayloadAttributeRangeLimits
    // this is not quite right as DownlinkPayloadAttributes is the raw object not the user control object
    //const validate = Payload.validateObject(desiredPayload ?? {}, limits)
    debug && console.log('desiredPayload', { desiredPayload });
    const pluckedEntries = Object.entries(desiredPayload ?? initial ?? {}).filter(([k, v]) => typeof v === 'number');
    return (_jsx(Card, { children: _jsx(CardContent, { children: _jsx(TableContainer, { style: { padding: '0.5em' }, children: _jsxs(Table, { style: { width: '100%' }, children: [_jsx(TableHead, { children: _jsxs(TableRow, { children: [_jsx(TableCell, { children: "Setting" }), _jsx(TableCell, { children: "Current" }), _jsx(TableCell, { children: "New" }), _jsx(TableCell, { children: "Set" })] }) }), _jsxs(TableBody, { children: [pluckedEntries.map(([k, v], i) => {
                                    const limits = GeneralDownlinkPayloadAttributeRangeLimits[k];
                                    const { attributeType, range: { min, max }, } = limits;
                                    const inputWidth = '5em';
                                    const keyWidth = '10em';
                                    const marks = max - min < 10;
                                    const step = marks ? 1 : 1;
                                    const payloadAttribute = (({ appCycleTime, sysCycleTime }) => ({ appCycleTime, sysCycleTime }))(desiredPayload ?? {});
                                    const reportedValue = reportedSettings?.[k];
                                    const currentValue = payloadAttribute?.[k] ?? 0;
                                    const setPayloadAttribute = (v, k) => {
                                        const clone = { ...desiredPayload, [k]: v };
                                        setDesiredPayload(clone);
                                        debug && console.log(`General Config set ${k} to ${v} and payload to`, clone);
                                    };
                                    return (_jsx(SimpleNumberRowGeneric, { i,
                                        keyWidth,
                                        k,
                                        inputWidth,
                                        v,
                                        payloadAttribute,
                                        reportedValue,
                                        currentValue,
                                        limits,
                                        min,
                                        marks,
                                        max,
                                        step,
                                        setPayloadAttribute,
                                        setHasEdits }, k));
                                }), _jsx(TableRow, { children: _jsx(TableCell, {}) })] }), _jsxs(TableFooter, { children: [_jsx(TableRow, { children: _jsxs(TableCell, { children: [_jsx(Button, { variant: 'contained',
                                                color: 'primary',
                                                size: 'small',
                                                disabled: selectedDevices.length === 0 || (reportedSettings && objectsMatch(reportedSettings, desiredPayload ?? {})),
                                                onClick: () => handleSendTransactionButtonClick(desiredPayload), children: "Send" }), _jsx(Button, { variant: 'contained',
                                                color: 'primary',
                                                size: 'small',
                                                disabled: objectsMatch(reportedSettings ?? {}, desiredPayload ?? {}),
                                                onClick: () => {
                                                    setDesiredPayload(reportedSettings ?? initial);
                                                    setHasEdits(false);
                                                }, children: "Reset" })] }) }), _jsx(TableRow, { children: _jsx(TableCell, { children: "\u00A0" }) }), _jsxs(TableRow, { style: {}, children: [_jsx(TableCell, { children: _jsx(Button, { variant: 'contained',
                                                color: 'primary',
                                                size: 'small',
                                                disabled: selectedDevices.length === 0,
                                                onClick: () => handleDownlinkReboot(), children: "Reboot" }) }), _jsx(TableCell, { children: _jsx(Button, { variant: 'contained',
                                                color: 'primary',
                                                size: 'small',
                                                disabled: selectedDevices.length === 0,
                                                onClick: () => handleDownlinkClearErrors(), children: "Clear Errors" }) }), _jsx(TableCell, { children: _jsx(Button, { variant: 'contained',
                                                color: 'primary',
                                                size: 'small',
                                                disabled: selectedDevices.length === 0,
                                                onClick: () => handleDownlinkRestore(), children: "Restore" }) }), _jsx(TableCell, { children: _jsx(Button, { variant: 'contained',
                                                color: 'primary',
                                                size: 'small',
                                                disabled: selectedDevices.length === 0,
                                                onClick: () => handleDownlinkReqConfig(), children: "Config" }) })] })] })] }) }) }) }));
};
